import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

import { logError } from '@/shared/logger'
import Button from '@/popup/components/shared/Button.vue'

// for short time we hide the tooltip so it can reposition for new content
const TOOLTIP_RESET_TIMEOUT = 3000
type Props = {
  value?: string
  copyText?: string
  copiedText?: string
  locked?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ClipboardButton',
  props: {
    value: { default: undefined },
    copyText: { default: '' },
    copiedText: { default: '' },
    locked: { type: Boolean, default: false }
  },
  setup(__props: any) {

const { t } = useI18n({ useScope: 'global' })

const props = __props

const copyText = ref(props.copyText || t('clipboard_copy.hover_text'))
const copiedText = ref(props.copiedText || t('clipboard_copy.copy_text'))
const copied = ref<NodeJS.Timeout | undefined>(undefined)

const saveToClipboard = (value: string) => {
  navigator.clipboard.writeText(value)
}

const handleClick = () => {
  if (!navigator.clipboard) {
    return logError(
      `[ClipboardCopy]: Your browser doesn't support navigator.clipboard API`
    )
  }

  if (props.value) {
    saveToClipboard(props.value)
    copied.value = setTimeout(() => {
      copied.value = undefined
    }, TOOLTIP_RESET_TIMEOUT)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Button, {
    variant: "primary",
    "is-full-width": true,
    onClick: handleClick
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(copied.value ? copiedText.value : copyText.value), 1 /* TEXT */)
    ]),
    _: 1 /* STABLE */
  }))
}
}

})